const placeTypeToZoomLevel = {
    administrative_area_level_1: 10,
    locality: 13,
    administrative_area_level_2: 12,
    sublocality: 14,
    administrative_area_level_3: 14,
    neighborhood: 13,
};

export default placeTypeToZoomLevel;
